import { mediaQuery } from 'modules/utils';
import { setIconColor, textClamp } from 'modules/utils/cssUtils';
import styled from 'styled-components';
import { theme } from '../theme';

interface SelectionBoxProps {
  selected?: boolean;
  disabled?: boolean;
}

export const StyledSelect = styled.p<SelectionBoxProps>`
  display: none;
  text-transform: uppercase;
  font-size: 0.875rem;
  font-weight: ${theme.fontWeight.bold};

  ${mediaQuery('md')} {
    display: flex;
    margin-top: 0.3rem;
    margin-bottom: 1.688rem;
  }
`;

export const HiddenRadioButton = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`;

export const StyledIconContainer = styled.div<SelectionBoxProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 1.5rem;

  ${mediaQuery('md')} {
    margin: 1.5rem 0 0.4rem 0;
  }

  svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;

  ${mediaQuery('md')} {
    align-items: center;
    justify-content: space-between;
    padding-top: 1rem;
  }
`;

export const StyledSelectionBoxContainer = styled.label<SelectionBoxProps>`
  height: 5rem;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  user-select: none;
  font-size: ${theme.fontSizes.body};
  border: 0.125rem;
  border-radius: 0.25rem;
  border-style: solid;

  ${mediaQuery('md')} {
    height: 10.313rem;
    width: 10.313rem;
    flex-direction: column;
  }

  cursor: pointer;

  ${(props) => {
    if (props.disabled) {
      return `
        background-color: transparent;
        border-color: ${theme.colors.primaryK3};

        ${StyledIconContainer} {
          ${setIconColor(theme.colors.primaryK3)}
        }

        ${StyledSelect} {
          color: ${theme.colors.primaryK3};
        }
        ${StyledTextContainer}{
          color: ${theme.colors.primaryK3};
        }
      `;
    }
    if (props.selected) {
      return `
        background-color: ${theme.colors.primaryW};

        ${mediaQuery('md')} {
          background-color: transparent;
        }

        border-color: ${theme.colors.primaryT2};

        ${StyledIconContainer} {
          ${setIconColor(theme.colors.primaryT2)}
        }

        ${StyledSelect} {
          color: ${theme.colors.primaryT2};
        }

        &:hover {
          border-color: ${theme.colors.primaryT1};

          ${StyledIconContainer} {
            ${setIconColor(theme.colors.primaryT1)}
          }
  
          ${StyledSelect} {
            color: ${theme.colors.primaryT1};
          }
        }
      `;
    }

    return `
      background-color: transprarent;
      border-color: ${theme.colors.primaryK10};

      &:hover {
        border-color: ${theme.colors.primaryK7};

        ${StyledIconContainer} {
          ${setIconColor(theme.colors.primaryK7)}
        }

        ${StyledSelect} {
          color: ${theme.colors.primaryK7};
        }
      }
  `;
  }};
`;

export const StyledSelectionBoxLabel = styled.div<SelectionBoxProps>`
  font-size: 0.875rem;
  line-height: 1.2;
  font-weight: ${theme.fontWeight.bold};
  text-transform: uppercase;
  padding: 0 1rem;
  text-align: center;
  ${textClamp({ maxLines: 2 })};
`;

export const StyledDetailLabel = styled.div<SelectionBoxProps>`
  ${textClamp({ maxLines: 2 })};
  font-weight: ${theme.fontWeight.thin};
`;
